/**
 * Main entry point for the engine package
 * @module @repo/engine
 */

// Re-export everything from core
export * from './core';

// React integration exports
export * from './react';

// DuckDB integration exports
export * from './duckdb-wasm';

// Re-export apache-arrow types that are commonly used
export type { DataType, Schema, Table } from 'apache-arrow';

// Export utility functions
export * from './utils'; 